// Конфигурация для разных окружений
export interface EnvironmentConfig {
  api: {
    baseURL: string;
    timeout: number;
  };
  app: {
    name: string;
    version: string;
    debug: boolean;
  };
  features: {
    enableLogging: boolean;
    enableAnalytics: boolean;
    enableErrorReporting: boolean;
  };
}

// Конфигурации для разных окружений
export const environments: Record<string, EnvironmentConfig> = {
  // Локальная разработка
  development: {
    api: {
      baseURL: 'http://localhost:5000/api/v1',
      timeout: 30000,
    },
    app: {
      name: 'Ryaskov.pro (Dev)',
      version: '2.0.0-dev',
      debug: true,
    },
    features: {
      enableLogging: true,
      enableAnalytics: false,
      enableErrorReporting: false,
    },
  },

  // Тестовое окружение
  testing: {
    api: {
      baseURL: 'https://ryaskov.pro/api/v1',
      timeout: 30000,
    },
    app: {
      name: 'Ryaskov.pro (Test)',
      version: '2.0.0-test',
      debug: true,
    },
    features: {
      enableLogging: true,
      enableAnalytics: false,
      enableErrorReporting: true,
    },
  },

  // Продакшен (реальный сервер)
  production: {
    api: {
      baseURL: 'https://ryaskov.pro/api/v1',
      timeout: 30000,
    },
    app: {
      name: 'Ryaskov.pro',
      version: '2.0.0',
      debug: false,
    },
    features: {
      enableLogging: false,
      enableAnalytics: true,
      enableErrorReporting: true,
    },
  },

  // Локальный сервер на другом IP
  localServer: {
    api: {
      baseURL: 'http://localhost:5000/api/v1',
      timeout: 30000,
    },
    app: {
      name: 'Ryaskov.pro (Local)',
      version: '2.0.0-local',
      debug: true,
    },
    features: {
      enableLogging: true,
      enableAnalytics: false,
      enableErrorReporting: false,
    },
  },
};

// Получить текущее окружение
export const getCurrentEnvironment = (): string => {
  // Сначала проверяем переменную окружения
  if (process.env.REACT_APP_ENVIRONMENT) {
    return process.env.REACT_APP_ENVIRONMENT;
  }
  
  // Затем проверяем NODE_ENV
  if (process.env.NODE_ENV === 'production') {
    return 'production';
  }
  
  if (process.env.NODE_ENV === 'test') {
    return 'testing';
  }
  
  // По умолчанию development (для подключения к локальному серверу)
  return 'development';
};

// Получить конфигурацию для текущего окружения
export const getEnvironmentConfig = (): EnvironmentConfig => {
  const currentEnv = getCurrentEnvironment();
  const config = environments[currentEnv];
  
  if (!config) {
    console.warn(`Конфигурация для окружения "${currentEnv}" не найдена. Используется development.`);
    return environments.development;
  }
  
  return config;
};

// Вспомогательная функция для переключения окружения в runtime (для отладки)
export const switchEnvironment = (envName: string): EnvironmentConfig | null => {
  const config = environments[envName];
  if (config) {
    console.log(`Переключение на окружение: ${envName}`, config);
    return config;
  } else {
    console.error(`Окружение "${envName}" не найдено. Доступные:`, Object.keys(environments));
    return null;
  }
};

export default environments;
